/**
 * Platform Menu — Menu lateral do Painel Administrativo Global (SaaS).
 *
 * Estrutura atualizada conforme as seções e rotas recomendadas do planejamento.
 */

export const PLATFORM_MENU = [
    // PRINCIPAL E USO FREQUENTE
    {
        label: "Visão Geral",
        icon: "ph-light ph-chart-pie-slice",
        path: "/platform",
        permission: "platform_dashboard",
    },
    {
        label: "CRM de Leads",
        icon: "ph-light ph-funnel",
        path: "/platform/crm",
        permission: "platform_crm",
    },
    {
        label: "Clientes / Academias",
        icon: "ph-light ph-buildings",
        path: "/platform/tenants",
        permission: "platform_tenants",
    },
    {
        label: "Minha Carteira",
        icon: "ph-light ph-briefcase",
        path: "/platform/portfolio",
        permission: "platform_portfolio",
    },
    {
        label: "Financeiro SaaS",
        icon: "ph-light ph-currency-circle-dollar",
        path: "/platform/billing",
        permission: "platform_billing",
    },
    {
        label: "Mercado Pago",
        icon: "ph-light ph-credit-card",
        path: "/platform/mercado-pago",
        permission: "platform_mercadopago",
    },
    {
        label: "Suporte / Chamados",
        icon: "ph-light ph-headset",
        path: "/platform/suporte",
        permission: "platform_support",
    },
    {
        label: "Onboarding",
        icon: "ph-light ph-clipboard-text",
        path: "/platform/onboarding",
        permission: "platform_onboarding",
    },

    // ADMINISTRAÇÃO
    {
        label: "Planos",
        icon: "ph-light ph-stack",
        path: "/platform/plans",
        permission: "platform_plans",
    },
    {
        label: "Usuários Internos",
        icon: "ph-light ph-users-three",
        path: "/platform/users",
        permission: "platform_users",
    },
    {
        label: "Permissões",
        icon: "ph-light ph-key",
        path: "/platform/permissions",
        permission: "platform_permissions",
    },
    {
        label: "Auditoria / Logs",
        icon: "ph-light ph-shield-check",
        path: "/platform/audit",
        permission: "platform_audit",
    },
    {
        label: "Métricas de Uso",
        icon: "ph-light ph-activity",
        path: "/platform/metricas",
        permission: "platform_metrics",
    },
    {
        label: "Notificações",
        icon: "ph-light ph-bell",
        path: "/platform/notificacoes",
        permission: "platform_notifications",
    },
    {
        label: "Configurações",
        icon: "ph-light ph-gear",
        path: "/platform/configuracoes",
        permission: "platform_settings",
    },
];
